// This file is auto-generated. Do not edit!

export default [
  {
    address: "0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0",
    symbol: "USDC.e",
  },
  {
    address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
    symbol: "WETH",
  },
  {
    address: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
    symbol: "WXDAI",
  },
  {
    address: "0x1D1498166DDCEeE616a6d99868e1E0677300056f",
    symbol: "xSPACE",
  },
  {
    address: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
    symbol: "USDC",
  },
  {
    address: "0x4ECaBa5870353805a9F068101A40E0f32ed605C6",
    symbol: "USDT",
  },
  {
    address: "0x0a06c8354A6CC1a07549a38701eAc205942E3Ac6",
    symbol: "BRZ",
  },
  {
    address: "0x0d8c4901Dd270Fe101B8014A5dbECC4e4432eB1E",
    symbol: "s-BFN",
  },
  {
    address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
    symbol: "AURA",
  },
  {
    address: "0x177127622c4A00F3d409B75571e12cB3c8973d3c",
    symbol: "COW",
  },
  {
    address: "0x1a5a62AE01EaD54e2Ead4F58d9B24643AeDc5C90",
    symbol: "s-TEST-LBP01",
  },
  {
    address: "0x1C67d859bD4a4e449d790b65fd6E28f982ae84B0",
    symbol: "s-BREAD",
  },
  {
    address: "0x1e2C4fb7eDE391d116E6B41cD0608260e8801D59",
    symbol: "bCSPX",
  },
  {
    address: "0x1f82284C1658Ad71C576f7230E6C2DEE7901c1FA",
    symbol: "wbTSLA",
  },
  {
    address: "0x216a7d520992eD198593A16e0b17c784c9cdc660",
    symbol: "POOL",
  },
  {
    address: "0x31B32b96049F8FD24969611252c4e44a1b4A07eB",
    symbol: "s-SCOUT",
  },
  {
    address: "0x420CA0f9B9b604cE0fd9C18EF134C705e5Fa3430",
    symbol: "EURe",
  },
  {
    address: "0x45508F2D63A36f5F45cB4a967bcC9ff05201b16a",
    symbol: "s-EPRG",
  },
  {
    address: "0x4d18815D14fe5c3304e87B3FA18318baa5c23820",
    symbol: "SAFE",
  },
  {
    address: "0x5198D513A6DBbA16637B353ce06197f750addB4B",
    symbol: "s-ETHCC",
  },
  {
    address: "0x51cFFACFfb9bF480c20023B625977c419146F12a",
    symbol: "s-ASTRO",
  },
  {
    address: "0x532801ED6f82FFfD2DAB70A19fC2d7B2772C4f4b",
    symbol: "SWPR",
  },
  {
    address: "0x5c154527cc33b9a5dA8F259A0745454f155e7D55",
    symbol: "s-GRD",
  },
  {
    address: "0x5Cb9073902F2035222B9749F8fB0c9BFe5527108",
    symbol: "GBPe",
  },
  {
    address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
    symbol: "wstETH",
  },
  {
    address: "0x7147A7405fCFe5CFa30c6d5363f9f357a317d082",
    symbol: "s-METESTSUP",
  },
  {
    address: "0x8e5bBbb09Ed1ebdE8674Cda39A0c169401db4252",
    symbol: "WBTC",
  },
  {
    address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
    symbol: "GNO",
  },
  {
    address: "0xa0ea681f5685BFa6857d776b5aCbf3D51bbeCC9a",
    symbol: "s-CBG",
  },
  {
    address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
    symbol: "sDAI",
  },
  {
    address: "0xC2366F0d00f274d1fB6ac761e7D66EAfD1b8C03D",
    symbol: "s-ZUB",
  },
  {
    address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
    symbol: "EURe",
  },
  {
    address: "0xCD2f64112ec04e21cC56F7bf2294A6A37790305e",
    symbol: "USDC.e",
  },
  {
    address: "0xcF873cC46bdD0e60d4b691c3936DE1C6aa8EEeE6",
    symbol: "s-gCRC",
  },
  {
    address: "0xD4dD9e2F021BB459D5A5f6c24C12fE09c5D45553",
    symbol: "ZCHF",
  },
  {
    address: "0xE0eD85F76D9C552478929fab44693E03F0899F23",
    symbol: "s-KPK",
  },
  {
    address: "0xf084b8F984912f0c62179Ca7EE998BeC90757B53",
    symbol: "s-crc-lx",
  },
  {
    address: "0xF490c80aAE5f2616d3e3BDa2483E30C4CB21d1A0",
    symbol: "osGNO",
  },
  {
    address: "0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73",
    symbol: "GHO",
  },
  {
    address: "0xFECB3F7c54E2CAAE9dC6Ac9060A822D47E053760",
    symbol: "BRLA",
  },
] as const
